
/**
 * 主界面左侧边栏组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
 
<template>
   <nav class="navbar-default navbar-static-side" role="navigation" style="z-index:55;">
        <div class="nav-close"><i class="fa fa-times-circle"></i>
        </div>
        <div class="sidebar-collapse" v-loading="loadingstatus.menu || loadingstatus.control || loadingstatus.pic" element-loading-text="菜单加载中" v-slimScroll="{height:'100%',railOpacity:0.9,alwaysVisible:false }">
             <ul class="nav" id="side-menu">
                    <li class="nav-header">
                        <div class="dropdown profile-element" @click="openAdmin">
                            <span>
                            	<img v-if="userimg===''" alt="image" class="img-circle" src="../../assets/project/images/default_logo.png" width="80" height="80"/>
                            	<img v-else alt="image" class="img-circle" :src="userImg" width="80" height="80"/>
                            </span>
                            <a data-toggle="dropdown" class="dropdown-toggle">
                                <span class="clear" style="margin-top:5px">
                                    <span class="block m-t-xs"><strong class="font-bold">{{userName}}</strong></span>
                                    <span class="text-muted text-xs block">{{adminName}}</span>
                                </span>
                            </a>
                        </div>
                        <div class="logo-element">
                        </div>
                    </li>
                    <li v-if="getDom" v-for="(tabOut,index1) in tabInfo" :key="index1" :class="{active:currentIndex == tabOut.No}" @click="clickable(tabOut,index1)">
                    	<a>
                            <i class="fa" :class="tabOut.icon" style="width:14px;text-align:center;"></i>
                            <span class="nav-label">{{tabOut.name}}</span>
                            <span class="fa arrow" v-if="tabOut.list.length>0"></span>
                        </a>
                        <ul class="nav nav-second-level collapse">
                            <li v-for="(tab,index) in tabOut.list" :key="index" :class="{active:currentIndex == tab.No}" @click="addTab(tab)" ref="profile">
                                <a class="J_menuItem" data-index="0">{{tab.name}}</a>
                            </li>  
                        </ul>
                    </li>                
                </ul>
        </div> 
        <!--管理员维护画面-->				
		<main-modal ref="modalAdmin" size="normal" title="个人信息维护" @close="closeAdmin">
			<div class="row">
			<!--	<div class="col-sm-12">-->
					<div class="form-horizontal">
						<div class="form-group">
							<label class="col-sm-3 control-label">工号</label>
							<div class="col-sm-6">
								<input type="text" class="form-control" v-model="userInfo.id" readonly>
							</div>
						</div>
						<div class="form-group">
							<label class="col-sm-3 control-label focus_color">*姓名</label>
							<div class="col-sm-6">
								<input type="text" class="form-control" v-model="userInfo.name" ref="currentname">
							</div>
						</div>
						<div class="form-group">
							<label class="col-sm-3 control-label">职务</label>
							<div class="col-sm-6">
								<input type="text" class="form-control" v-model="userInfo.job">
							</div>
						</div>
						<div class="form-group">
							<label class="col-sm-3 control-label focus_color">*电话</label>
							<div class="col-sm-6">
								<input type="text" class="form-control" v-model="userInfo.mobile" ref="currentphone">
							</div>
						</div>
						<div class="form-group">
							<label class="col-sm-3 control-label focus_color">*帐号</label>
							<div class="col-sm-6">
								<input type="text" class="form-control" v-model="userInfo.account" readonly ref="currentemail">
							</div>
						</div>
						<!--<div class="form-group">
							<label class="col-sm-3 control-label focus_color">邮箱</label>
							<div class="col-sm-9">
								<input type="text" class="form-control" v-model="userInfo.account" readonly ref="currentemail">
							</div>
						</div>-->
					</div>
			<!--	</div>-->
				<!--<div class="col-sm-6 text-center">
					<div v-if="!isBinded">
						微信扫描二维码，即可使用微信企业版查车平台！<br />
						随时随地，掌上查车！<br />
						<img style="width: 150px; height: 150px;" :src="codeSrc"/>
					</div>
					<div v-if="isBinded">
						<br /><br />
						您已绑定微信版查车平台
						<br /><br />
						微信名：{{wechatName}}
						<br /><br />
						<button class="btn btn-primary" @click="cancelBind">点击解绑</button>
					</div>
				</div>-->
			</div>
			
			<div slot="footer">
				<button class="btn btn-primary" @click="saveInfo">保存</button>
			    <button v-if="permission.indexOf('information_resetPassword') == -1" 
			    	class="btn btn-primary" @click="changePassword">修改密码</button>
			</div>
		</main-modal>
		
		 <!--密码维护画面-->				
		<main-modal ref="modalPassword" size="normal" title="修改密码">
			<div class="row">
				<div class="col-sm-11">
					<div class="form-horizontal">
						<div class="form-group">
							<label class="col-sm-3 control-label">请输入原密码</label>
							<div class="col-sm-9" v-if="pwType.a0 === 'password'">
								<input type="password" class="form-control" v-model="pwParams.oldPw" ref="oldpw1">
								<span class="glyphicon form-control-feedback" v-bind:class="pwClass[0]" @click="handleEye(0)"></span>
							</div>
							<div class="col-sm-9" v-if="pwType.a0 === 'text'">
								<input type="text" class="form-control" v-model="pwParams.oldPw" ref="oldpw2">
								<span class="glyphicon form-control-feedback" v-bind:class="pwClass[0]" @click="handleEye(0)"></span>
							</div>
						</div>
						<div class="form-group">
							<label class="col-sm-3 control-label">请输入新密码</label>
							<div class="col-sm-9" v-if="pwType.a1 === 'password'">
								<input type="password" class="form-control" v-model="pwParams.newPw" ref="newpw1">
								<span class="glyphicon form-control-feedback" v-bind:class="pwClass[1]" @click="handleEye(1)"></span>
							</div>
							<div class="col-sm-9" v-if="pwType.a1 === 'text'">
								<input type="text" class="form-control" v-model="pwParams.newPw" ref="newpw2">
								<span class="glyphicon form-control-feedback" v-bind:class="pwClass[1]" @click="handleEye(1)"></span>
							</div>
						</div>
						<div class="form-group">
							<label class="col-sm-3 control-label">请再输入一遍</label>
							<div class="col-sm-9" v-if="pwType.a2 === 'password'">
								<input type="password" class="form-control" v-model="pwParams.cfmPw" ref="cfmpw1">
								<span class="glyphicon form-control-feedback" v-bind:class="pwClass[2]" @click="handleEye(2)"></span>
							</div>
							<div class="col-sm-9" v-if="pwType.a2 === 'text'">
								<input type="text" class="form-control" v-model="pwParams.cfmPw" ref="cfmpw2">
								<span class="glyphicon form-control-feedback" v-bind:class="pwClass[2]" @click="handleEye(2)"></span>
							</div>
						</div>
					</div>
				</div> 
			</div>
			
			<div slot="footer">
				<button class="btn btn-primary" @click="cancelPw">取消</button>
			    <button v-if="permission.indexOf('information_resetPassword') == -1" 
			    	class="btn btn-primary" @click="changePassword('start')">确定修改</button>
			</div>
		</main-modal>
		
		
		
		
        <!--页面tab弹框组件开始-->				
		<main-modal ref="modalTip" size="small" title="提示" >
			<p v-text="tipContent"></p>	
			<div slot="footer">
				<button class="btn btn-primary" @click="closetip">关闭</button>
			</div>
		</main-modal>
   </nav>
</template>

<script>
	import {mapState} from 'vuex'
	import VueCoreImageUpload from 'vue-core-image-upload'
	import {SERVICE_NO} from 'static/constant'
	import MainModal from 'components/common/MainModal'
	import { MENU_EXCEPTION,OPERATE_EXCEPTION,LOGIN_USER_EMPTY,PHONE_FAILE,MOBILE_FAILE,EMAIL_FAILE,EMAIL_EXCEPTION,OPERATE_SUCCESS } from 'static/message'
	import {upperCase,isEmail} from 'util/util'
	import metisMenu from 'metismenu'
	
  export default {
    name: 'Sidebar',
    components: {
		MainModal,
		VueCoreImageUpload
	},
    data() {
      return {
      	permission:this.$store.state.permission.permission["information"]?this.$store.state.permission.permission["information"]:[],
      	loadingstatus:{
      		menu:false,
      		control:false,
      		pic:false
      	},
      	userInfo:{
      		id:'',
      		name:'',
      		job:'',
      		mobile:'',
      		email:'',
      		displayPic:'',
      		account:''
      	},
      	logoSrc:'',
      	admin:this.$store.state.user.admin,
       	tabInfo:[],
       	clickedIndex:0,
       	getDom:false,
       	tipContent:'',
       	changeSuccess:false,
       	isBinded:false,					//是否绑定微信号
       	timer:"",						//判断用户扫描二维码的轮询器
       	codeSrc:"",						//二维码地址
       	wechatName:"",					//微信名
       	pwParams: {
       		oldPw: "",
       		newPw: "",
       		cfmPw: ""
       	},
       	pwClass:["glyphicon-eye-close",
		       	"glyphicon-eye-close",
		       	"glyphicon-eye-close"],
	    pwType:{
	    	a0:"password",
	    	a1:"password",
	    	a2:"password"
	    }
      };
    },
    computed:{
    	...mapState({
			currentIndex:state => state.home.currentIndex,
			userimg:state=>state.user.userimg
		}),
		adminName:function(){
			let name ='';
			if (this.admin=="1"){
				name='企业管理员'
			}
			if (this.admin=="0"){
				name='企业一般用户'
			}
			if (this.admin=="9"){
				name='超级管理员'
			}
			return name;
		},
		userName:function(){
			return this.$store.state.user.username;
		},
		accesstoken:function(){
			return this.$store.state.user.accesstoken
		},
		userImg:function(){
			return process.env.PIC_BASE_PATH + this.$store.state.user.userimg
		}
	},
    beforeMount(){
    	//   process.env.API_ROOT + /account/roles/menu
    	//   ../../static/sidebar3.json
    	this.loadingstatus.menu = true;
    	this.$http.get(process.env.API_ROOT + '/account/menu')
    		.then((response)=>{
				if(response.data.success){
					const resInfo = response.body.data;
					this.$set(this,"tabInfo",resInfo)//成功获取数据---content不为空	
				//	this.tabInfo.shift()
						let tag = '';
						let tagUpperCase = '';
						
						for(let i = 0,length = this.tabInfo.length; i < length; i++){
							const tabClickable = this.tabInfo[i].list;	
							
							if(tabClickable.length>0){
								for(let j = 0, length = tabClickable.length; j < length; j++){	
									tag = tabClickable[j].code;									
									tagUpperCase = upperCase(tag);
									tabClickable[j].No = tag,
									tabClickable[j].id = 'Page' + tagUpperCase,
									tabClickable[j].route = '/indexhome/' + tag
								}
							}else{
								tag = this.tabInfo[i].code;
								tagUpperCase = upperCase(tag);
								this.tabInfo[i].No = tag,
								this.tabInfo[i].id = 'Page' + tagUpperCase,
								this.$store.dispatch('setDefaultMenu',this.tabInfo[0].code=="vehicleMonitor"?2:1)
								if (this.tabInfo[i].code=="vehicleMonitor" || this.tabInfo[i].code=="monitorVehicle"){
									this.tabInfo[i].route = '/indexhome'
								}else{
									this.tabInfo[i].route = '/indexhome/' + tag  
								}
						}				
					} 
					this.getDom = true;
					this.loadingstatus.menu = false;
				}else{
					this.opentip(response.data.message);
					this.loadingstatus.menu = false;
				}
			},(response)=>{
				this.opentip(response.data.message);
				this.loadingstatus.menu = false;
			})
    	this.loadingstatus.control = true;
    	this.$http.get(process.env.API_ROOT + '/account/page-control')
			.then( res => {
				if(res.body.success){
					const resInfo = res.body.data;	//ctlCodeList
					if (resInfo){
						this.$store.dispatch('setpermission',JSON.stringify(resInfo));
					}
					this.loadingstatus.control = false;
				} else {
					this.opentip(res.body.message);
					this.loadingstatus.control = false;
				}
			}, res => {
				this.opentip(res.body.message);
				this.loadingstatus.control = false;
			}).catch( res => {
				this.opentip(OPERATE_EXCEPTION);
				this.loadingstatus.control = false;
			})
		this.loadingstatus.pic = true;
		this.$http.get(process.env.API_ROOT + '/account/customers/' + this.$store.state.user.groupid)
			.then( res => {
				if(res.body.success){
					if(res.body.data) {
						const resinfo = res.body.data;
						this.$store.dispatch('saveUserInfo',resinfo)
					//	this.$store.dispatch('get')
						this.$store.dispatch('setuserimg',resinfo.logo);
					}
					this.loadingstatus.pic = false;
				} else {
					this.opentip(res.body.message);
					this.loadingstatus.pic = false;
				}
			}, res => {
				this.opentip(res.body.message);
				this.loadingstatus.pic = false;
			}).catch( res => {
				this.opentip(OPERATE_EXCEPTION);
				this.loadingstatus.pic = false;
			})		
    },
    updated(){
    	$('#side-menu').metisMenu();
    },
    methods:{
    	clickable(tabOut,index1){
    		if(tabOut.list.length==0){
    			this.addTab(tabOut)
    		}
    		this.clickedIndex = index1
    	},
    	addTab:function(obj){
    		this.$router.push(obj.route)
    		this.$store.dispatch('addTab',obj);	
    	},
    	opentip(message){
			this.tipContent=message;
			this.$refs.modalTip.open();	
		},
    	closetip(){
    		this.changeSuccess&&this.$refs.modalAdmin.close();
			this.$refs.modalTip.close();	
			this.changeSuccess=false;
		},
		openAdmin(){
			
			this.$http.get(process.env.API_ROOT + '/account/accounts/init')
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;	
						this.userInfo=resInfo;
						this.logoSrc=process.env.PIC_PATH + this.userInfo.displayPic;
						this.$refs.modalAdmin.open();	
					//	this.getBindState();
					} else {
						this.opentip(res.body.message);
					}
				}, res => {
					this.opentip(res.body.message);
				}).catch( res => {
					this.opentip(OPERATE_EXCEPTION);
				})
		},
		closeAdmin(){
			if(this.timer){
				clearInterval(this.timer);
			}
		},
		//保存
		saveInfo(){
			if(!this.userInfo.name) {
				this.opentip(LOGIN_USER_EMPTY);
				this.$refs.currentname.focus();
				return;
			}
			if(!this.userInfo.mobile) {
				this.opentip(PHONE_FAILE);
				this.$refs.currentphone.focus();
				return;
			}
			if(!(/^1[3|4|5|7|8]\d{9}$/.test(this.userInfo.mobile))){
				this.opentip(MOBILE_FAILE);
				this.$refs.currentphone.focus();
				return;
			}
			if(!this.userInfo.account) {
				this.opentip(EMAIL_FAILE);
				this.$refs.currentemail.focus();
				return;
			}
			this.$http.put(process.env.API_ROOT + '/account/accounts/info',this.userInfo)
				.then( res => {
					if(res.body.success){
						this.changeSuccess=true;
						this.opentip(OPERATE_SUCCESS);
						if (this.userInfo.name!=this.userName){
							this.$store.dispatch('setusername',this.userInfo.name);
						}
					} else {
						this.opentip(res.body.message);
					}
				}, res => {
					this.opentip(res.body.message);
				}).catch( res => {
					this.opentip(OPERATE_EXCEPTION);
				})
		},
		//重置密码
		resetPassword(){
			///account/accounts/password
			this.$http.post(process.env.API_ROOT + '/account/accounts/password?userId='+this.userInfo.id) 
	    		.then( res => {
					if(res.data.success){
						this.changeSuccess=true;
						this.opentip("您的密码重置链接已经发送到您的邮箱，请查收邮件并按指引完成密码重置");
					} else {
						this.opentip(res.data.message);
					}
				}, res => {
					this.opentip(res.data.message)
				}).catch( res => {
					this.opentip(OPERATE_EXCEPTION)
				})
		},
		//修改密码
		changePassword(flag){
			const { pwParams } = this;
			if(flag == 'start'){
				if(!(pwParams.oldPw && pwParams.newPw && pwParams.cfmPw)){
					this.opentip("输入不能为空")
					return;
				}
				if(pwParams.newPw.length < 6){
					this.opentip("密码必须大于6位")
					this.$refs.newpw1.focus();
					return;
				}
				if(pwParams.newPw !== pwParams.cfmPw){
					this.opentip("两次密码输入不相同，请重新输入")
					this.$refs.newpw1.focus();
					return;
				}
				// 修改密码
				this.$http.put(process.env.API_ROOT + '/account/resetPassword',{oldPassword:pwParams.oldPw,newPassword:pwParams.newPw}) 
	    		.then( res => {
					if(res.data.success){
						this.opentip(OPERATE_SUCCESS);
						this.cancelPw();
						pwParams.oldPw = "";
						pwParams.newPw = "";
						pwParams.cfmPw = "";
					} else {
						this.opentip(res.data.message);
					}
				}, res => {
					this.opentip(res.data.message)
				}).catch( res => {
					this.opentip(OPERATE_EXCEPTION)
				})
			} else {
				this.$refs.modalPassword.open();
				this.$refs.oldpw1.focus();
			}
		},
		cancelPw(){
			this.$refs.modalPassword.close();
		},
		handleEye(flag){
			if(this.pwClass[flag] === "glyphicon-eye-close"){
				this.pwClass[flag] = "glyphicon-eye-open";
				this.pwType["a" + flag] = "text"
			} else {
				this.pwClass[flag] = "glyphicon-eye-close";
				this.pwType["a" + flag] = "password"
			}
		},
		//获取二维码地址
		get2dCode(){
			this.$http.get(process.env.API_ROOT + '/account/accounts/createqr')
				.then( res => {
					if(res.data.success){
						this.codeSrc = res.data.data;
					}
				}, res => {
					this.opentip(res.data.message)
				})
		},
		//判断用户是否已绑定微信
		getBindState(){
			//如果已经绑定，则显示解除绑定按钮，不再显示二维码
			this.$http.get(process.env.API_ROOT + '/account/accounts/wechat/check')
				.then( res => {
					if(res.data.data){
						// 已经绑定
						this.wechatName = res.data.data;
						this.isBinded = true;
					} else {
						//若没有绑定，则显示二维码
						this.isBinded = false;
						this.get2dCode();
						this.bindStateLooper();
					}
				}, res => {
					this.opentip(res.data.message)
				})
		},
		//点击解除绑定按钮
		cancelBind(){
			this.$http.put(process.env.API_ROOT + '/account/accounts/wechat/unbind')
				.then( res => {
					if(res.data.success){
						//如果解绑成功，则重新显示二维码，并启动轮询器
						this.get2dCode();
						this.isBinded = false;
						this.bindStateLooper();
						this.opentip("解绑成功")
					}
				}, res => {
					this.opentip(res.data.message)
				})
			
		},
		//启动轮询器，若用户已扫描二维码，则发出消息告知用户，并不再显示二维码
		bindStateLooper(){
			const that = this;
			this.timer = setInterval(function(){
				that.$http.get(process.env.API_ROOT + '/account/accounts/wechat/check')
					.then( res => {
						if(res.data.data){
							// 已经绑定
							that.wechatName = res.data.data;
							clearInterval(that.timer);
							that.isBinded = true;
						}
					}, res => {
						that.opentip(res.data.message)
					})
			},3000)
		}
    }
  };  
</script>
<style>
	.form-control-feedback{
	    cursor: pointer;
	    pointer-events: auto !important;
	    margin-right: 8px;
	    cursor:hand;
	}
</style>


// WEBPACK FOOTER //
// Sidebar.vue?a3028b6e